import { Spin, Typography } from "antd";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import TextEllipsis from "@/components/Elements/TextEllipsis";

const { Text } = Typography;

const TextFieldPreview = ({ value, ellipsis, loading }) => {
  if (loading)
    return (
      <span role="status">
        <Spin size="small" />
      </span>
    );

  if (!value) return FIELD_PREVIEW_DEFAULT_VALUE;

  if (ellipsis) return <TextEllipsis>{value}</TextEllipsis>;

  return <Text>{value}</Text>;
};

export default TextFieldPreview;
